import idb from "@/plugins/indexdb.js";
import DropdownsRepository from "../../repositories/dropdownsRepository";

export default {
  namespaced: true,
  state: {
    dropdowns: []
  },
  mutations: {
    // Set dropdowns
    setDropdowns(state, dropdowns) {
      state.dropdowns = dropdowns;
    },

    // Clean dropdowns object
    cleanDropdowns(state) {
      state.dropdowns = [];
    }
  },
  actions: {
    // Get all dropdowns from api
    async getDropdowns({ commit }) {
      try {
        const { data } = await DropdownsRepository.get();
        commit("setDropdowns", data);

        let dropdowns = [];

        // Add manual id for IndexedDB
        data.id = 1;
        dropdowns.push(data);

        await idb.db.dropdowns.bulkPut(dropdowns);
      } catch (error) {
        throw error;
      }
    },

    // Get product dropdowns from IndexedDB
    async getLocalDropdownsByProduct(context, product) {
      try {
        const dropdowns = await idb.db.dropdowns.toArray();
        return dropdowns[0][product];
      } catch (error) {
        throw error;
      }
    },

    // Get local articles from IndexedDB
    async getLocalArticle(context, article_id) {
      try {
        const res = await idb.db.articles.get(article_id);
        return res;
      } catch (error) {
        throw error;
      }
    },

    // Get local articles from IndexedDB
    async getLocalArticlesByModel(context, model) {
      try {
        const res = await idb.db.articles
          .where({ product_model: model })
          .toArray();

        return res.sort((a, b) => {
          if (a.order) {
            a.order - b.order;
          }
        });
      } catch (error) {
        throw error;
      }
    },

    // Clean store
    cleanArticles({ commit }) {
      commit("setProjects", []);
    }
  }
};
